/* eslint-disable @typescript-eslint/naming-convention */
import { SocketService } from '../../services/socket.service';
import { DepositTabComponent } from '../user-dash/deposit-tab/deposit-tab.component';
import { WithdrawTabComponent } from '../user-dash/withdraw-tab/withdraw-tab.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../abstraction/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { DataLayerService } from '../../services/utils/data-layer.service';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { CryptoService } from '../../abstraction/crypto.service';
import { AnimationOptions } from 'ngx-lottie';
import { MissingDataDialogComponent } from './missing-data-dialog/missing-data-dialog.component';
import {
  CONFIRM_DIALOG_TYPE,
  ConfirmDialogComponent,
  ConfirmDialogData,
} from 'src/app/modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { DOCUMENT_STATUS, IBundle, USER_LABEL, User } from '../../models/User';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  showJueguin = !environment.production;
  mainTitle = '';
  mailResent = false;
  showOptions: boolean;
  showButtons: boolean;
  showMenuMobile: boolean;
  showBundle = false;
  isCompany: boolean;
  isCommerce: boolean;
  isMarketClosed = false;
  showDashboardLoader = true;
  twoSecondsTimeout = false;
  options: AnimationOptions = {
    path: '/assets/animations/dashboard-loader/data.json',
  };
  actualYear: number = new Date().getFullYear();
  missingDataDialogRef: MatDialogRef<MissingDataDialogComponent>;
  isMarket = false;
  USER_LABEL = USER_LABEL;
  DOCUMENT_STATUS = DOCUMENT_STATUS;

  constructor(
    public authService: AuthService,
    public apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private readonly sso: ScrollStrategyOptions,
    public dialog: MatDialog,
    public dataLayer: DataLayerService,
    private socketService: SocketService,
    private cryptoService: CryptoService,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.titleService.setTitle('TiendaCrypto | Dashboard');
    this.metaService.addTag({
      name: 'description',
      content:
        'Compra y vende tus criptomonedas de forma segura y fácil en TiendaCrypto, Obteniendo los mejores precios del mercado',
    });
    this.cryptoService.getCryptoPrices();
  }

  ngOnInit() {
    setInterval(() => {
      if (this.socketService.socketTimestamp < Date.now() - 5000) {
        this.socketService.connect();
      }
    }, 300000);

    if (this.authService.loggedUser)
      this.authService.sendTikTokPageView(window.location.href).subscribe();
    this.isCompany = this.authService.isCompany();
    this.isCommerce = this.authService.loggedUser?.isCommerce;
    // Loading animation logic, tarda mínimo dos segundos, o hasta que llegue los prices correctamente
    setTimeout(() => {
      this.twoSecondsTimeout = true;
      if (Object.keys(this.cryptoService.prices.value).length !== 0) {
        this.showDashboardLoader = false;
      }
    }, 2000);
    this.cryptoService.prices.subscribe((prices) => {
      if (this.showDashboardLoader && Object.keys(prices).length !== 0 && this.twoSecondsTimeout) {
        this.showDashboardLoader = false;
      }
    });
    this.socketService.initialize();

    this.showOptions = false;
    this.showMenuMobile = false;
    if (this.router.url === '/crypto-exchange' || this.router.url === '/dca') this.isMarket = true;
    this.mainTitle = this.getMainTitle();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.mainTitle = this.getMainTitle();
        if (event.url === '/') {
          this.titleService.setTitle('TiendaCrypto | Dashboard');
        }
        if (event.url === '/dca') this.isMarket = true;
      }
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.logout) {
        this.authService.logout();
      }
    });
    this.authService.isMarketClosed.subscribe((value) => {
      this.isMarketClosed = value;
    });
    this.authService.loggedUserObs.subscribe((user: User) => {
      if (!user) return;
      if (user.balance.bundle) {
        this.setShowBundles(user.balance.bundle);
      }
      if (user) {
        this.validateUserData();
      }
    });
    setTimeout(() => {
      if (this.authService.hasToUpdateWork() && this.authService.hasValidatedDNIS()) {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Actualizá tus datos',
              content: 'Necesitamos que declares tu actividad.',
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.router.navigate(['auth', 'signup', 'data-extra']);
          });
      }
      if (this.authService.loggedUser?.label === USER_LABEL.REQUIRES_DOCUMENTATION) {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Falta documentación',
              content: 'Necesitamos que subas documentación que justifique tus operaciones',
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.router.navigate(['profile', 'documentation']);
          });
      }
      if (
        this.authService.loggedUser?.label === USER_LABEL.UNKNOWN_IDENTITY &&
        this.authService.loggedUser.fundsDocuments.selfie !== DOCUMENT_STATUS.PENDING
      ) {
        this.dialog
          .open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Validar identidad',
              content:
                'Necesitamos validar su identidad, por favor, suba una foto selfie con DNI en mano, junto con un cartel que indique la fecha actual, y la siguiente leyenda "Quiero operar en Tienda Crypto"',
            },
          })
          .afterClosed()
          .subscribe(() => {
            this.router.navigate(['profile', 'selfie']);
          });
      }
    }, 2000);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle('TiendaCrypto');
  }

  openDialog(type: string) {
    if (type === 'alert') {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Ocurrió un error',
          content: 'No se, hay que ver que pasó, si no no se entiende. Seguro fue back.',
          errorCode: 'TUTTI_BROKEN',
          acceptLabel: 'Oka',
        },
      });
    }
    if (type === 'tick') {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: '¡Depósito acreditado!',
          content: `Tu depósito de 100 BTC se acreditó con éxito. Ya podés ver tu nuevo saldo en tu portfolio.`,
          tick: true,
        },
      });
    }
    if (type === 'confirm') {
      this.dialog
        .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Creación de grupo',
            content: `¿Estás seguro de crear el grupo “<span class="name-group">San Miguel de Tucumán</span>”?`,
            acceptLabel: 'Confirmar',
          },
        })
        .afterClosed()
        .subscribe((res) => console.log(res));
    }
    if (type === 'countdown') {
      this.dialog
        .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
          panelClass: 'modal-container',
          disableClose: true,
          data: {
            title: 'Ha ocurrido un error.',
            content: 'El precio ha expirado. Por favor, intenta de nuevo',
            errorCode: 'ANY_ERROR',
            acceptLabel: 'Reintentar',
            type: CONFIRM_DIALOG_TYPE.COUNTDOWN,
            timeToActivate: 10,
          },
        })
        .afterClosed()
        .subscribe((res) => console.log(res));
    }
    if (type === 'agreement') {
      let cuitConfirmMessage = `Vas a registrarte con el CUIT/CUIL <b>43035328</b>. <br> ¿Deseas continuar?`;

      this.dialog
        .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
          panelClass: 'modal-container',
          disableClose: true,
          data: {
            title: 'Verificación',
            content: cuitConfirmMessage,
            acceptLabel: 'Si',
            rejectLabel: 'No',
            agreementText: 'Acepto que la información mostrada es correcta.',
          },
        })
        .afterClosed()
        .subscribe((res) => {
          console.log(res);
        });
    }
  }

  validateUserData() {
    if (this.authService.needToCompletedOnboarding() || this.missingDataDialogRef) return;
    const phoneNumber = this.authService.loggedUser.phoneNumber?.trim();
    const isPhoneNumberValid = phoneNumber && phoneNumber.length >= 10 && !isNaN(+phoneNumber);

    if (!isPhoneNumberValid) {
      this.missingDataDialogRef = this.dialog.open(MissingDataDialogComponent, {
        panelClass: 'modal-container',
        disableClose: true,
      });
    }
  }

  openDialogDeposit() {
    if (this.authService.checkOnboardingStatus()) {
      this.dialog.open(DepositTabComponent, {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'deposit',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        scrollStrategy: this.sso.block(),
      });
    }
  }

  openDialogWithdraw(type: string) {
    if (this.authService.checkOnboardingStatus()) {
      const params = {
        backdropClass: 'dialog-primary-backdrop',
        panelClass: 'deposit',
        width: '40%',
        maxWidth: '748px',
        minWidth: 'fit-content',
        scrollStrategy: this.sso.reposition({
          autoClose: false,
          scrollThrottle: 300,
        }),
        data: undefined,
      };
      if (type !== 'all' && type !== '') {
        params.data = type;
      }

      const dialogRef = this.dialog.open(WithdrawTabComponent, params);

      dialogRef.afterClosed().subscribe((data) => {
        // Volver a llamar a la funcion que actualiza el saldo
        // this.ngOnInit();
        // location.reload();
      });
    }
  }

  showUserName() {
    if (!this.authService.loggedUser.name) {
      return this.authService.loggedUser.email.substr(
        0,
        this.authService.loggedUser.email.indexOf('@'),
      );
    }
    if (this.authService.loggedUser.name.length > 21) {
      return this.authService.loggedUser.name.slice(0, 21) + '..';
    } else {
      return this.authService.loggedUser.name;
    }
  }

  showOptionsClick() {
    if (this.authService.loggedUser) {
      this.showOptions = !this.showOptions;
    }
  }

  getMainTitle() {
    const currentPath = window.location.pathname.split('/')[1];
    switch (currentPath) {
      case 'crypto-exchange':
        return 'Mercado';
      case 'swap':
        return 'Swap';
      case 'prode':
        return 'Prode';
      case 'history':
        return 'Historial de operaciones';
      case 'profile':
        return 'Perfil';
      case 'aust':
        return 'aUST';
      case 'payroll':
        return 'Sueldos Crypto';
      case 'canastas':
        return 'Canastas';
      case 'commerce':
        return 'Commerce';
      case 'dca':
        return 'DCA';
      case 'grupos':
        return 'Grupos';
      default:
        return 'Dashboard';
    }
  }

  setShowBundles(bundles: IBundle) {
    this.showBundle = false;
    Object.keys(bundles).forEach((keyBundle) => {
      Object.keys(bundles[keyBundle]).forEach((coin) => {
        Object.values(bundles[keyBundle][coin]).forEach(
          (values: { amount: string; weiAmount: string }) => {
            if (+values.amount > 0) {
              this.showBundle = true;
              return;
            }
          },
        );
      });
    });
  }

  openAndCloseMarket() {
    this.showOptions = false;
    this.isMarket = !this.isMarket;
    if (this.isMarket) this.router.navigateByUrl('/crypto-exchange');
  }
}
